import classNames from "classnames/bind";
import React, { forwardRef } from "react";
import styles from "./Card.module.scss";
import type { CardProps } from "./types";

const cx = classNames.bind(styles);

export const Card = forwardRef<HTMLDivElement, CardProps>(
  (
    {
      onClick,
      children,
      colorVariant = "default",
      style,
      className,
      ...restProps
    },
    ref
  ) => {
    return (
      <div
        ref={ref}
        className={cx(
          "container",
          { isLink: !!onClick },
          colorVariant && `is-color-${colorVariant}`,
          className
        )}
        onClick={onClick}
        style={style}
        {...restProps}
      >
        {children}
      </div>
    );
  }
);

Card.displayName = "Card";
